module.exports = __webpack_public_path__ + "img/contact_img.14c028ae.png";